import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 2000-2999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const orgStructureErrors = {
  // Live at packages/server/orgUnits/orgUnits.mongo.service.ts:310-315.
  ORGANISATION_STRUCTURE_TYPE_NOT_EXIST: {
    errorCode: 2002,
    errorMessage: t("Organisation type does not exist"),
    isDynamic: false,
  },
  // Live at packages/server/orgUnits/orgUnits.mongo.service.ts:330-335. This call site used to send
  // ORGANISATION_STRUCTURE_TYPE_NOT_EXIST (2002) for this exact message — a real miscategorization
  // bug, fixed alongside adding this entry: two refusals that mean different things get their own
  // codes rather than sharing one.
  ORGANISATION_STRUCTURE_REPORTS_TO_NOT_EXIST: {
    errorCode: 2004,
    errorMessage: t("ReportsTo unit does not exist"),
    isDynamic: false,
  },
  // Live at packages/server/organisations/organisations.mongo.service.ts:1159-1165.
  ORGANISATION_USERS_EXISTS: {
    errorCode: 2100,
    errorMessage: t("An active portal user still belongs to this organisation."),
    isDynamic: false,
  },
  // Live at packages/server/organisations/organisations.mongo.service.ts:1166-1172.
  ORGANISATION_CONTRACT_EXISTS: {
    errorCode: 2101,
    errorMessage: t("A contract still references this organisation."),
    isDynamic: false,
  },
  // The orgUnits module's only generic site, continuing the 2xxx org-structure series.
  ORG_UNIT_NOT_FOUND: {
    errorCode: 2006,
    errorMessage: t("Org unit not found"),
    isDynamic: false,
  },
  // 2007-2008 came off NO_CHANGES_APPLIED (9005).
  ORG_TYPE_IN_USE: {
    errorCode: 2007,
    errorMessage: t("This Org Type is already in use. To Delete selected Org Type, remove it from Org Structure."),
    isDynamic: false,
  },
  ORG_UNIT_ID_IN_USE: {
    errorCode: 2008,
    errorMessage: t("UnitId already in use"),
    isDynamic: false,
  },
  // 2009-2011 arrived with staging's org-unit move/update work. 2009 exists because that call site
  // sent ORGANISATION_STRUCTURE_TYPE_NOT_EXIST (2002) with the prose "Parent unit does not exist" —
  // two different statements. With the prose gone the code alone is what the user reads, and 2002
  // says "Organisation type does not exist", which is not what that guard checked.
  ORG_UNIT_PARENT_NOT_FOUND: {
    errorCode: 2009,
    errorMessage: t("Parent unit does not exist"),
    isDynamic: false,
  },
  ORG_UNIT_TARGET_PARENT_NOT_FOUND: {
    errorCode: 2010,
    errorMessage: t("Target parent org unit not found"),
    isDynamic: false,
  },
  ORG_UNIT_MOVE_INTO_OWN_SUBTREE: {
    errorCode: 2011,
    errorMessage: t("Cannot move an org unit under itself or one of its descendants"),
    isDynamic: false,
  },
  // `deleteOrgTypes`: a request naming one of the portal's seeded (isDefault) Org Unit Types is refused whole.
  ORG_TYPE_DEFAULT_NOT_DELETABLE: {
    errorCode: 2012,
    errorMessage: t("Default Org Unit Types cannot be deleted."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
